import $ from 'jquery';
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { $Elements, Durations, Events } from './constants';

// Track Swiper initialization to refresh ScrollTrigger after all instances are ready
let swiperInitCount = 0;
let totalSwiperCount = 0;

// Function to refresh ScrollTrigger after all Swiper instances are initialized
function refreshScrollTriggerAfterSwiper() {
	if(swiperInitCount >= totalSwiperCount && totalSwiperCount > 0) {
		// All Swiper instances have been initialized
		console.log(`All ${totalSwiperCount} Swiper instances initialized, refreshing ScrollTrigger`);
		// Add a small delay before refreshing to ensure all elements are properly rendered
		setTimeout(() => {
			ScrollTrigger.refresh();
		}, 100);
	}
}

$Elements.document.on(Events.page.enter, () => {
	// Reset counters on each page enter
	swiperInitCount = 0;

	// Count total number of potential Swiper instances
	totalSwiperCount = $('.content-section.team-carousel-section .section-carousel, .content-section .column-carousel').length +
		$('.content-section.team-slider-section .section-carousel, .content-section .column-carousel').length +
		$('.content-section .section-slideshow, .content-section .column-slideshow').length;

	// ---------- Team Carousel ----------

	$('.content-section.team-carousel-section .section-carousel').each(function() {
		const slideCount = this.querySelectorAll('.swiper-slide').length;

		if(!this.swiper) {
			const container = this;

			const swiper = new Swiper(container, {
				speed: Durations.animations.ms,
				slidesPerView: 'auto',
				//spaceBetween: 20,
				centerInsufficientSlides: true,
				observer: true,
				loop: false,

				on: {
					beforeInit: function() {
						updateAfterNext(this);
						swiperInitCount++;
						refreshScrollTriggerAfterSwiper();
					},
					slideChangeTransitionStart: function() {
						updateAfterNext(this);
					}
				}
			});

			function updateAfterNext(swiperInstance) {
				const allSlides = swiperInstance.slides;
				allSlides.forEach(slide => slide.classList.remove('after-next'));

				const nextIndex = swiperInstance.activeIndex + 1;
				const afterNext = allSlides[nextIndex + 1];
				if(afterNext) {
					afterNext.classList.add('after-next');
				}
			}
		}
	});

	// ---------- Team Slider ----------

	$('.content-section.team-slider-section .section-carousel, .content-section .column-carousel').each(function() {

		if(!this.swiper) {
			const container = this;

			const swiper = new Swiper(container, {
				speed: Durations.animations.ms,
				slidesPerView: 'auto',
				//spaceBetween: 20,
				centerInsufficientSlides: true,
				centeredSlides: true,
				observer: true,
				loop: true,
				autoplay: false,
				autoHeight: true,
				modules: [Navigation, Autoplay],
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
				breakpoints: {
					1024: {
						autoHeight: false,
					},
				},
				on: {
					afterInit: function() {
						swiperInitCount++;
						refreshScrollTriggerAfterSwiper();
					}
				}
			});
		}
	});

	// ---------- Slideshow ----------

	$('.content-section .section-slideshow').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				loop: true,
				observer: true,
				autoplay: true,
				effect: 'fade',
				modules: [Autoplay, EffectFade, Navigation, Pagination],
				fadeEffect: {
					crossFade: true,
				},
				pagination: {
					el: this.querySelector('.swiper-pagination'),
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
				on: {
					afterInit: function() {
						swiperInitCount++;
						refreshScrollTriggerAfterSwiper();
					}
				}
			});
		}
	});

	$('.vertical-cards-section .column-slideshow').each(function() {

		if(!this.swiper) {
			const swiperContainer = this;

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				observer: true,
				effect: 'fade',
				modules: [EffectFade],
				fadeEffect: {
					crossFade: true,
				},
				on: {
					afterInit: function() {
						swiperInitCount++;
						refreshScrollTriggerAfterSwiper();

						const parentSection = swiperContainer.closest('.vertical-cards-section');

						if(parentSection) {
							const collapses = parentSection.querySelectorAll('.accordion .accordion-collapse');

							// Si un panneau est déjà ouvert au chargement, positionner le bon slide immédiatement
							const initiallyOpenIndex = Array.from(collapses).findIndex(c => c.classList.contains('show'));
							if(initiallyOpenIndex > -1) {
								swiper.slideTo(initiallyOpenIndex + 1, 0, false);
							}

							collapses.forEach((el, idx) => {
								// Déclenché après l'ouverture complète (transition terminée)
								el.addEventListener('shown.bs.collapse', function() {
									swiper.slideTo(idx + 1, Durations.animations.ms, false);
									// Laisse le layout se stabiliser puis rafraîchis ScrollTrigger
									requestAnimationFrame(() => {
										try { ScrollTrigger.refresh(); }
										catch(e) {}
									});
								});

								// Déclenché après la fermeture complète (transition terminée)
								el.addEventListener('hidden.bs.collapse', function() {
									const allClosed = Array.from(collapses).every(c => !c.classList.contains('show'));
									if(allClosed) {
										swiper.slideTo(0, Durations.animations.ms, false);
									}
									requestAnimationFrame(() => {
										try { ScrollTrigger.refresh(); }
										catch(e) {}
									});
								});
							});
						}
					}
				}
			});
		}
	});


	// If no Swiper instances were found, still refresh ScrollTrigger
	// This handles the case where the page doesn't have any Swiper carousels
	if(totalSwiperCount === 0) {
		ScrollTrigger.refresh();
	}
});
